import { render, staticRenderFns } from "./procuracao.vue?vue&type=template&id=09fd3eb7&"
import script from "./procuracao.vue?vue&type=script&lang=js&"
export * from "./procuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports